import { Layout, Menu } from 'antd';
import { ReactComponentElement, useCallback, useEffect, useState } from 'react';
import styles from "./Sidebar.module.scss";
import greenwiselogo from '../../../globals/images/Layout/balanceimg.png';
import greenwiseicon from '../../../globals/images/Layout/balance.png';
import empresaChubb from '../../../globals/images/Layout/empresa-chubb.png'; // Importa el logo de Chubb

import SideBarSubMenu from './SidebarSubMenu';
import Navbar from './Navbar';
import {
    LogoutOutlined
} from '@ant-design/icons';
import { getStyleCookie, logout } from '../../../services/auth';
import useMediaQuery from '../hooks/useMediaQuery';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { Module, UserState } from '../../../store/user/types';
import { useHistory } from 'react-router-dom';
import iconMap from './iconMapping';
import { getAllModuleToken } from 'src/store/user/thunks';
import { getStylesByOrganization } from 'src/store/organization/thunks';


const { Header, Content, Sider } = Layout;
interface MenuItem {
    sequential: string;
    label: string;
    link: string;
    icon?: string;
    keySubModule: string;
}
interface UserProps {
    getAllModuleToken: any;
    getStylesByOrganization: any;
    children: any;
    user: UserState;
}

// ** Mapeo de estilos de organización a rutas de imagen **
// Este objeto te permitirá obtener la ruta de importación correcta de la imagen
// basándote en el valor de la cookie de estilo.
const organizationLogoMap: { [key: string]: string } = {
    "empresaChubb": empresaChubb, // Si getStyleCookie devuelve "chubb", usa empresaChubb
    // Agrega más mapeos si tienes otros estilos de organización que cambian el logo
};


const SideBar: React.FC<UserProps> = (props: UserProps) => {
    const history = useHistory();
    const [dataTableModule, setDataTableModule] = useState<Module[]>([]);
    const [collapsed, setCollapsed] = useState(true);

    const init = async () => {
        const responseDataRespone = await props.getAllModuleToken();
        await props.getStylesByOrganization();
        console.log(responseDataRespone);
        setDataTableModule(responseDataRespone);
    };

    useEffect(() => {
        init();
        handleCollapse(true);
    }, []);

    const queries = {
        md: "(max-width: 768px)",
    };
    const matches = useMediaQuery(queries.md);

    const onLogout = async () => {
        await logout();
        history.push('/');
    };

    // Inicializa con el logo por defecto o el que corresponda si ya hay un estilo en la cookie
    const initialStyle = getStyleCookie();
    const initialLogo = initialStyle && organizationLogoMap[initialStyle] ? organizationLogoMap[initialStyle] : greenwiseicon;

    const [isImageLogo, setImageLogo] = useState(initialLogo);
    const [isLogoStyle, setIsLogoStyle] = useState("");
    const [isLogOut, setIsLogOut] = useState("");

    const handleCollapse = (value: boolean) => {
        setCollapsed(value);
        const styleOrganization = getStyleCookie(); // Obtén el valor de la cookie
        if (value) {
            setImageLogo(greenwiseicon) // Icono si está colapsado
            setIsLogOut("")
            setIsLogoStyle("")
        } else {
            // Si hay un estilo de organización en la cookie y está mapeado a un logo
            if (styleOrganization && organizationLogoMap[styleOrganization]) {
                setImageLogo(organizationLogoMap[styleOrganization]); // <-- **CORRECCIÓN AQUÍ**
                setIsLogOut("Cerrar sesión")
                setIsLogoStyle("-complete")
            }
            else {
                setImageLogo(greenwiselogo) // Logo completo por defecto
                setIsLogOut("Cerrar sesión")
                setIsLogoStyle("-complete")
            }
        }
    };


    return (
        <div className={styles["layout-admin-container"]}>
            <Layout>
                {!matches && (
                    <Sider collapsible collapsed={collapsed} onCollapse={handleCollapse} className={styles["layout-admin-sider"]}>

                        <div className={styles["layout-admin-logo" + isLogoStyle]}>
                            <img loading="lazy" src={isImageLogo} alt="GreenLogo" />
                        </div>
                        <Menu className={styles["layout-admin-menu"]} mode="vertical">
                            <>
                                {dataTableModule.map((singleOption: any) => {
                                    const IconComponent = iconMap[singleOption.icon];

                                    if (!IconComponent) {
                                        console.warn(`Icon "${singleOption.icon}" not found in iconMap`);
                                    }
                                    return (
                                        <>
                                            {singleOption.items.length > 0 ?

                                                <Menu.SubMenu
                                                    style={{ color: 'black', backgroundColor: '#ffffff' }}
                                                    title={
                                                        <div className={styles["layout-admin-text"]}>
                                                            {IconComponent && <IconComponent />}
                                                            <span>{singleOption.label}</span>
                                                        </div>
                                                    }
                                                >
                                                    {singleOption.items.map((child: MenuItem) => {
                                                        const ChildIconComponent = child.icon ? iconMap[child.icon] : null;

                                                        return (
                                                            <Menu.Item
                                                                key={child.keySubModule}
                                                                onClick={() => history.push(`/${child.link}`)}
                                                                style={{ color: 'black', backgroundColor: '#ffffff' }}
                                                            >
                                                                <div className={styles["layout-admin-submenu-item-text"]}>
                                                                    {ChildIconComponent && <ChildIconComponent />}
                                                                    <span>{child.label}</span>
                                                                </div>
                                                            </Menu.Item>
                                                        );
                                                    })}
                                                </Menu.SubMenu>
                                                : <Menu.Item
                                                    key={singleOption.keySubModule}
                                                    onClick={() => history.push(`/${singleOption.link}`)}
                                                    style={{ color: 'black', backgroundColor: '#ffffff' }}
                                                    title={singleOption.label} //
                                                >
                                                    <div className={styles["layout-admin-text"]}>
                                                        {IconComponent && <IconComponent />}
                                                        <span>{singleOption.label}</span>
                                                    </div>
                                                </Menu.Item>}
                                        </>

                                    );
                                })}

                            </>
                        </Menu>
                        <div onClick={onLogout} className={styles["layout-admin-header-logout" + isLogoStyle]}>
                            <LogoutOutlined /> {isLogOut}
                        </div>
                    </Sider>
                )}
                <Layout>
                    <Content className={styles["layout-admin-content"]}>
                        {props.children}
                    </Content>
                </Layout>
            </Layout>
        </div>
    );
}
const mapStateToProps = (state: AppState) => ({
    user: state.user
});
export default connect(mapStateToProps, {
    getAllModuleToken,
    getStylesByOrganization

})(SideBar);

//OLVIDAR